module.exports = __webpack_public_path__ + "508b00c4093930ab09a9b1bd096339c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic.jpg
// module id = 173
// module chunks = 1